jQuery(document).ready(function ($) {
    var forum_topic_module = $('.forum-topic-module');
    var top_bookmakers_module = forum_topic_module.find('.top-bookmakers-module');
    var top_bookmakes = forum_topic_module.find('.topBookmakes');
    var sidebar_modules = $('.sidebar-container');
    top_bookmakes.addClass('sidebar-bookmaker');
    
    if (sidebar_modules.find('.top-bookmakers-module')) {
        sidebar_modules.find('.topBookmakes').addClass('sidebar-bookmaker');
    } 

    if (top_bookmakers_module.length) {
        if (forum_topic_module) {
            $(window).scroll(function (e) {
                if (window.pageYOffset + $('#top-navigation').height() > top_bookmakers_module.offset().top - 16 && window.pageYOffset <= $('body').height() + $('#top-navigation').height() - window.innerHeight - $('.footer').height()) {
                    top_bookmakers_module.addClass('position-sticky');
                    top_bookmakers_module.css('top', $('#top-navigation').height() + 16);
                }
            });
        }
    }

 

    $(window).scroll(function (e) {
        if (window.pageYOffset + $('#top-navigation').height() >= $('.main-page-content').offset().top - 16) {
            $('.addss').css('top', $('#top-navigation').height());

            if (window.pageYOffset + $('#top-navigation').height() >= 500 + $('.main-page-content').offset().top) {
                $('.addss').css('height', 'max-content');
            }
        }
        if (window.pageYOffset + $('#top-navigation').height() <= $('.main-page-content').offset().top - 16) {
            $('.addss').css('top', 16);
            $('.addss').css('height', 0);
        }
    });


});

